// extracted by mini-css-extract-plugin
export default {"modalText":"XsG6fWmF","doneIcon":"KdcF4CLp","modalOptionText":"LSmkybha","modalWrapper":"NvNPlF1K"};